import React from 'react';
import { Layout, Text, ListItem, Icon} from '@ui-kitten/components';
import { useQuery } from '@apollo/react-hooks';
import { Q_GET_SURVEY_PARTICIPANTS } from '../../data/api/query/q_survey';
import { FlatList, View } from 'react-native';
import { CardItem, SurveyTypeHeader } from '../../components/list-items/CardItem';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions } from '../../utils/useScreenInfo';
import { BasicCard, ListHeader } from '../../components/_primatives';





export function SurveyParticipantListScreen({ navigation, route }): React.ReactElement {
    const { pageSpacerHorizontal, isMediumScreenOrLarger, bodyWidth } = useScreenDimensions();
    const params = route?.params;
    console.log({ navigation, route, params });
    const surveyId: string = params.survey || params.survey_id;
    const { loading, error, data } = useQuery(Q_GET_SURVEY_PARTICIPANTS, {
        variables: { survey_id: surveyId },
        fetchPolicy: 'network-only'
    });


    if (loading) return <PageLoadingIndicator />;
    if (error)  { console.log('useQuery', error); return <Text>Error :(</Text> };
    console.log('we have data, ', data)
    const survey: any = data.surveys[0];
    if (!survey || survey.length === 0) return <Text>Survey not found</Text>;

    const userAnswers: any = [...survey.user_answers, ...survey.anon_user_answers];

    const renderHeader = () => (
        <ListHeader
            title={'Participants'}
            isMediumScreenOrLarger={isMediumScreenOrLarger}
        >
            {/* <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap' }}>
                <Text category='s1'>{`Total Survey Participants: ${userAnswers.length}`}</Text>
            </View> */}
        </ListHeader>
    );
    const renderFooter = () => (
        <View style={{ height: 100 }}>
        </View>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ borderWidth: 0 }}>
            <Text category='p1'>{'This survey doesn\'t have any participants yet'}</Text>
        </BasicCard>
    );
    const renderUser = ({ item }) => {
        console.log('participant = ', item);
        const user: ParticipantUser = item.user;
        return (
            <Participant
                username={user.username}
                dateCreated={item.created_at}
                isMediumScreenOrLarger={isMediumScreenOrLarger}
            />
        );
    };
    const keyExtractor = (item: CardItem) => item.id;


    return (
        <Layout level='1' style={{ flex: 1 }}>
            <FlatList
                data={userAnswers}
                renderItem={renderUser}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
                keyExtractor={keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
                ListEmptyComponent={listEmptyComponent}
            />
        </Layout>
    );
}



interface ParticipantProps {
    username: string;
    dateCreated: string;
    status?: string;
    isMediumScreenOrLarger: boolean;
}

const Participant = (props: ParticipantProps) => {
    return (
        <BasicCard style={props.isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', }}>
                <Icon name={'person'} style={{ marginRight: 20 }} height={25} width={25} fill='rgb(143, 155, 179)' />
                <View style={{ flex: 1 }}>
                    <Text category='s1' style={{ fontWeight: 'bold' }}>{props.username}</Text>
                    <Text category='p1' appearance='hint'>{props.dateCreated ? (new Date(props.dateCreated).toLocaleDateString()) + ' ' + new Date(new Date()).toLocaleTimeString(): ''}</Text>
                </View>
            </View>
        </BasicCard>
    );
};



interface ParticipantUser {
    username: string;
}